import { __awaiter } from "tslib";
import { useMST } from '@hooks/MSTHook';
import useOnlyNewUsers from '@hooks/useOnlyNewUsers';
import { useFlag } from '@lusha/experiment-react-sdk';
import AppDispatcher from '@reducers/app/dispatcher';
import FlagsDispatcher from '@reducers/flags/dispatcher';
import { useAppDispatch } from '@reducers/index';
import SettingsDispatcher from '@reducers/settings/dispatcher';
import _ from 'lodash';
import { communicator } from 'lusha-widgets';
import { useEffect } from 'react';
import { useAsyncFetch } from 'react-hooks-async-handlers';
import { AUTO_OPEN_OFF_MOMENT } from './const/featureMoments';
import { FLAGS } from './experiments/flags';
import { messaging } from './lib/messaging';
function AppInt(props) {
    const { children } = props;
    const { userSettings } = useMST(store => ({ user: store.user, userSettings: store.userSettings }));
    const dispatch = useAppDispatch();
    const isNewAutoOpenUser = useOnlyNewUsers(AUTO_OPEN_OFF_MOMENT);
    const autoOpenFlag = useFlag(FLAGS.AUTO_OPEN_DEFAULT.key, { preload: isNewAutoOpenUser });
    const isTestEnabled = autoOpenFlag.data.variationKey === FLAGS.AUTO_OPEN_DEFAULT.variations.TEST;
    useEffect(() => {
        if (autoOpenFlag.isFetched) {
            dispatch(SettingsDispatcher.actions.setAutoOpenDefault(!isTestEnabled));
        }
    }, [autoOpenFlag]);
    useAsyncFetch(() => __awaiter(this, void 0, void 0, function* () {
        yield dispatch(AppDispatcher.install());
    }));
    useEffect(() => {
        communicator.getMessenger('SETTINGS', {
            listen: true,
            handshake: true,
        }, externalSettings => {
            console.log('appInit event', externalSettings);
            if (_.isPlainObject(externalSettings)) {
                userSettings === null || userSettings === void 0 ? void 0 : userSettings.loadExternal(externalSettings);
            }
        });
        // basically it is duplicate, but I need it for experiments
        function onMessage(event) {
            return __awaiter(this, void 0, void 0, function* () {
                if (!_.isObject(event.data))
                    return null;
                const { type, payload } = event.data;
                console.log('received event', type, payload, event);
                switch (type) {
                    case 'SETTINGS': {
                        dispatch(SettingsDispatcher.actions.set(payload));
                        // @important: note that it is overrides handler under Master
                        break;
                    }
                    case 'FLAG/PULL': {
                        dispatch(FlagsDispatcher.set(payload));
                        break;
                    }
                    default:
                        break;
                }
            });
        }
        window.addEventListener('message', onMessage, false);
        messaging.sendMessage('APP_INIT');
        console.log('init listeners()');
        return () => {
            // doesn't suppose to happen, but there is bug with 2 mounts
            window.removeEventListener('message', onMessage);
        };
    }, []);
    return children;
}
export default AppInt;
